import { render, staticRenderFns } from "./interactionsIndicator.vue?vue&type=template&id=d2915b88"
import script from "./interactionsIndicator.vue?vue&type=script&lang=js"
export * from "./interactionsIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports